<template>
<div class="mx-6">
  <v-alert
      class="rounded-xl myClass"
      height="100px"
      v-model="config.enabled"
      prominent
      dismissible
      outlined
      text
      :color="config.color"
      :icon="config.icon"
    >
      <h4 class="black--text">{{config.title}}</h4>
      <h5 class="message-content section-helpers mt-1"
      >{{config.content}}</h5>
  </v-alert>
</div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    config: {
      type: Object,
      default: undefined,
    },
  },
  created() {
    if (this.config.enabled) {
      this.getElement();
    }
  },
  methods: {
    async getElement() {
      const alertCloseIcon = await document.getElementsByClassName('mdi-close-circle');
      // Check if element exists before manipulating it
      if (alertCloseIcon && alertCloseIcon.length > 0 && alertCloseIcon[0]) {
        // tag_element[0].classList.replace('green--text', 'black--text');
        // tag_element[0].classList.push('black--text');
        alertCloseIcon[0].classList.add('black--text');
        alertCloseIcon[0].classList.replace('mdi-close-circle', 'mdi-close');
      }
    },
  },
};
</script>
<style>
.myClass {
  margin: 0px;
  width: 100%;
  height: 100%;
}
.message-content {
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 0.54);
}
@media only screen and (max-width: 374px) {
  .myClass {
  height: 255px !important;
  display: flex;
  align-items: center;
}
}
@media only screen and (min-width: 375px) and (max-width: 705px) {
  .myClass {
  height: 171px !important;
  display: flex;
  align-items: center;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1264px) {
  .myClass {
  height: 125px !important;
  display: flex;
  align-items: center;
}
}

</style>
